"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triStateMapper = void 0;
const triStateMapper = (whenTrue, whenFalse, whenNull) => (v) => {
    if (v === true) {
        return whenTrue;
    }
    else if (v === false) {
        return whenFalse;
    }
    else if (v === null) {
        return whenNull;
    }
    throw new Error('Invalid value passed to triState!');
};
exports.triStateMapper = triStateMapper;
